import { render, staticRenderFns } from "./facebook-link.vue?vue&type=template&id=22f4790f&"
import script from "./facebook-link.vue?vue&type=script&lang=js&"
export * from "./facebook-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports